import React from 'react';
import UnknownDumbView from '../../../../DeviationViews/Dumbo/Unknown';
import s from './Unknown.scss';
const UnknownMonoReactView = (props)=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(UnknownDumbView, {
        width: 350,
        height: 313,
        deviation: props.deviation
    }));
};
UnknownMonoReactView.displayName = 'UnknownMonoReactView';
export default UnknownMonoReactView;
